import React, { useState, useEffect } from "react";
import { styled } from "baseui";
import { Modal } from "baseui/modal";
import { Fragment } from "react";

const StyledDiv = styled("div", ({ $theme }) => ({
  width: "100%",
  cursor: "pointer",
}));

export default function ContextContainer(props) {
  const [xPos, setxPos] = useState("0px");
  const [yPos, setyPos] = useState("0px");
  const [showMenu, setshowMenu] = useState(false);

  const handleClick = (e) => {
    if (showMenu) setshowMenu(false);
  };

  const handleContextMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (showMenu) return;
    setshowMenu(true);
    setxPos(`${e.clientX}px`);
    setyPos(`${e.clientY}px`);
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [showMenu]);
  return props.enabled ? (
    <StyledDiv onContextMenu={(e) => handleContextMenu(e)}>
      <Modal
        closeable={false}
        isOpen={showMenu}
        nstable_ModalBackdropScroll
        overrides={{
          Backdrop: {
            style: ({ $theme }) => ({
              opacity: "0",
            }),
          },
          Dialog: {
            style: ({ $theme }) => ({
              position: "fixed",
              left: xPos,
              top: yPos,
              width: "150px",
              padding: "0px",
              margin: "0px",
            }),
          },
        }}
      >
        {
          <props.menu
            onMenuItemClick={props.onContextMenuItemClick}
            node={props.node}
          />
        }
      </Modal>
      {props.children}
    </StyledDiv>
  ) : (
    <Fragment>{props.children}</Fragment>
  );
}
